module.exports = __webpack_public_path__ + "img/trusted-shops-logo.950d59c.avif";